var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',_vm._b({},'v-skeleton-loader',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }